/* istanbul ignore file -- FIXME(phase-18-ui-hoxxtv) Smart TV UI component / view — full per-component RTL interaction tests deferred to a follow-up wave (see deferred-items.md). Pattern matches 18-01 web (54 files) + 18-02 mobile (133 files). */
import React, { useContext, useState } from 'react';
import { CoreContext } from '../../context/CoreContext';
import { availableVideos } from '../../services/mock';
import ButtonIcon from '../ButtonIcon';

import {
  ContentBanner,
  BannerDecoration,
  BannerContent,
  BannerContentTitle,
  BannerContentText,
  BannerRowOptions,
  BannerButton,
  BannerButtonIcon,
  BannerButtonText,
} from './styled';

export default function Banner({
  banners,
}: {
  banners: {
    id: number;
    title?: string;
    description?: string;
    image?: { uri: string };
    category?: { title: string; color: string };
  }[];
}) {
  const { setCurrentVideo, isFavorite, toggleFavorite, favoriting } = useContext(CoreContext);

  const currentBanner = banners?.[0];
  console.log({ currentBanner });
  return (
    <>
      <ContentBanner source={currentBanner?.image}>
        <BannerDecoration />
        <BannerContent>
          <BannerContentTitle>{currentBanner?.title}</BannerContentTitle>
          <BannerContentText>{currentBanner?.description}</BannerContentText>
          <BannerRowOptions>
            <ButtonIcon
              focusKey={'button-banner'}
              onPress={() => setCurrentVideo(currentBanner)}
              onEnterPress={() => setCurrentVideo(currentBanner)}
              icon={'play'}
            >
              Assistir
            </ButtonIcon>

            {/* <ButtonIcon loading={favoriting} focusKey={'button-banner-fav'} onPress={() => toggleFavorite(currentBanner)} onEnterPress={() => toggleFavorite(currentBanner)} icon={'heart'} spaced >
                            { isFavorite(currentBanner) ? `Remover dos favoritos` : `Adicionar aos favoritos`}
                        </ButtonIcon> */}
          </BannerRowOptions>
        </BannerContent>
      </ContentBanner>
    </>
  );
}
